var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,1C10.9,1,5.9,6,5.9,12.1c0,3.7,1.9,7.2,4.9,9.3v1.2v1.6v2.9h1v2.9h1V33h8.5v-2.9h1v-2.9h1v-2.9l0-2.9 c3.1-2.1,4.9-5.5,4.9-9.2C28.1,6,23.1,1,17,1z M19.6,31.4h-5.3v-1.3h5.3V31.4z M20.6,28.5h-7.2v-1.3h7.2V28.5z M21.6,25.5h-9.2v-1.3 h9.2V25.5z M15.7,22.6l-1-6.6l0.9,0.7l1.4-1.4l1.4,1.4l0.9-0.7l-1,6.6H15.7z M22,20.2l-0.4,0.2l0,2.2h-1.7l1.3-8.9L20,13.5L20,13.4 l-0.1,0.1l-0.2,0l0,0.2l-1.1,0.8L17,12.9l-1.5,1.5l-1.1-0.8l0-0.2l-0.2,0L14,13.4L14,13.5l-1.2,0.2l1.3,8.9h-1.7v-2.1L12,20.2 c-2.8-1.7-4.5-4.8-4.5-8.1c0-5.2,4.3-9.5,9.5-9.5s9.5,4.3,9.5,9.5C26.5,15.4,24.8,18.4,22,20.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIot);
export default __webpack_public_path__ + "static/media/iot.dd4d700e3faa82974bd6f0b561541f4e.svg";
export { ForwardRef as ReactComponent };